module.exports = require("@walletconnect/legacy-provider");